/** Taille d'affichage seulement. Les coordonnées GPS ne changent pas. */
export function pinSize(zoom, phone, selected) {
  const level = Number(zoom) || 13;
  let size = 44;
  if (level <= 13) size = phone ? 36 : 44;
  else if (level === 14) size = phone ? 48 : 50;
  else size = phone ? 56 : 58;
  if (selected) size = Math.round(size * 1.12);
  return size;
}
